/**
 *
 * Asynchronously loads the component for SyncJobList
 *
 */

import loadable from '../../utils/loadable';

export default loadable(() => import('./index'));
